const INSTRUCTIONS = {
    scan: [
        'Please wait while scanning module is loading, it may take 5-15 sec',
        'Ensure only single face is being captured for quick processing',
        'Change phone orientation landscape/portrait for more accuracy',
        'Stand in front of a plain background with good lighting',
        'Ensure your face is fully visible without any obstructions',
        'Maintain a neutral facial expression and look directly at the camera',
        'Adjust the face to include only your head and shoulders'
    ],
};


export default {
    ...INSTRUCTIONS
};